import { useCallback } from "react";

import {
  DEFAULT_PANEL_POSITION,
  type PanelPosition,
} from "@/components/VibeChat/widgets/FloatingWidget/panel-constants";
import useSessionStorageState, { SESSION_STORAGE_KEYS } from "@/hooks/useSessionStorageState";

export const usePanelPosition = (): [PanelPosition, (position: PanelPosition) => void] => {
  const [panelPosition, setPanelPositionState] = useSessionStorageState<PanelPosition>(
    SESSION_STORAGE_KEYS.VIBE_PANEL_POSITION,
    DEFAULT_PANEL_POSITION,
  );

  const setPanelPosition = useCallback(
    (position: PanelPosition) => {
      setPanelPositionState(position);
    },
    [setPanelPositionState],
  );

  return [panelPosition, setPanelPosition];
};
